import { render } from "./ConstruccionPagina.vue?vue&type=template&id=c7273d0a"
import script from "./ConstruccionPagina.vue?vue&type=script&lang=js"
export * from "./ConstruccionPagina.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__